export const PURCHASE_ORDER_DIVISION_PERMISSION = {
  VIEW: 'PURCHASE_ORDER_DIVISION_VIEW',
  ADD: 'PURCHASE_ORDER_DIVISION_ADD',
  EDIT: 'PURCHASE_ORDER_DIVISION_EDIT',
  DEL: 'PURCHASE_ORDER_DIVISION_DEL',
  REVIEW: 'PURCHASE_ORDER_DIVISION_REVIEW',
  ADD_NEW_REVIEW: 'PURCHASE_ORDER_DIVISION_ADD_NEW_REVIEW',
  ADD_USER_REVIEW: 'PURCHASE_ORDER_DIVISION_ADD_USER_REVIEW',
};

export const DIVISION_TYPE_OPTIONS = [
  {
    value: 0,
    label: 'Giao thẳng về kho cửa hàng',
    shortLabel: 'Giao thẳng cửa hàng',
    description:
      'Dùng khi nhà cung cấp giao trực tiếp về kho cửa hàng. Chỉ nên gom các đơn mua cùng một nhà cung cấp.',
    sourceFieldLabel: 'Đơn mua nguồn',
    stockFieldLabel: 'Không dùng kho tổng',
    storeSectionTitle: 'Cửa hàng nhận hàng trực tiếp',
    productSectionTitle: 'Tổng hợp sản phẩm giao thẳng',
  },
  {
    value: 1,
    label: 'Chia hàng từ kho tổng',
    shortLabel: 'Chia từ kho tổng',
    description:
      'Dùng khi hàng đã nhập kho tổng trước, sau đó mới điều chuyển nội bộ về các cửa hàng. Đơn mua chỉ là chứng từ tham chiếu; số lượng chia phải bám theo hàng đã nhập tại kho nguồn.',
    sourceFieldLabel: 'Đơn mua tham chiếu',
    stockFieldLabel: 'Kho nguồn để chia',
    storeSectionTitle: 'Cửa hàng nhận điều chuyển',
    productSectionTitle: 'Sản phẩm đã nhập tại kho nguồn',
  },
  {
    value: 2,
    label: 'Chia hàng đơn đặt trước qua kho tổng',
    shortLabel: 'Đơn đặt trước qua kho tổng',
    description:
      'Dùng cho hàng đơn đặt trước gom về kho tổng rồi phân bổ tiếp cho cửa hàng theo đơn đặt trước.',
    sourceFieldLabel: 'Đơn hàng nguồn',
    stockFieldLabel: 'Kho tổng đơn đặt trước',
    storeSectionTitle: 'Cửa hàng nhận theo đơn đặt trước',
    productSectionTitle: 'Sản phẩm đơn đặt trước chờ phân bổ',
  },
];

const DIVISION_TYPE_MAP = DIVISION_TYPE_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export const getDivisionTypeConfig = (value) => DIVISION_TYPE_MAP[Number(value)] || DIVISION_TYPE_OPTIONS[1];

export const getDivisionTypeLabel = (value, options = {}) => {
  const { short = false } = options;
  const config = getDivisionTypeConfig(value);
  return short ? config.shortLabel : config.label;
};

export const reviewTypeOptions = [
  {
    label: 'Chưa duyệt',
    colorLabel: 'bw_black',
    className: '',
    icon: 'fi-rr-minus',
    value: null,
  },
  {
    label: 'Đã duyệt',
    colorLabel: 'bw_green',
    className: 'bw_agree',
    icon: 'fi-rr-check',
    value: 1,
  },
  {
    label: 'Không duyệt',
    colorLabel: 'bw_red',
    className: 'bw_non_agree',
    icon: 'fi-rr-minus',
    value: 0,
  },
];
